var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPhone = function SvgPhone(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.922 11.267-1.705-.569a1.766 1.766 0 0 0-1.807.427c-.403.403-.982.572-1.469.275a7.017 7.017 0 0 1-1.295-1.047A7.014 7.014 0 0 1 8.6 9.06c-.297-.488-.128-1.066.275-1.47A1.766 1.766 0 0 0 9.3 5.784l-.568-1.705a2 2 0 0 0-2.078-1.36l-1.066.098c-.762.069-1.418.57-1.533 1.326-.275 1.8-.24 5.33 3.116 8.686 3.355 3.356 6.885 3.391 8.686 3.116.757-.115 1.257-.77 1.326-1.533l.097-1.066a2 2 0 0 0-1.36-2.078Z",
    stroke: "#1B2230",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPhone;